import { AlertCircle as ErrorIcon, InformationOutline as InfoIcon, AlertOutline as WarningIcon } from 'mdi-material-ui';
import { Notice } from '@/core';

/**
 * Takes in a notice type (error, info, or warning) and returns the correct status icon
 */
export const getIconFromNoticeType = (type: Notice['type']) => {
  switch (type) {
    case 'error':
      return <ErrorIcon sx={(theme) => ({ color: theme.palette.status.error.main })} fontSize="small" />;
    case 'warning':
      return <WarningIcon sx={(theme) => ({ color: theme.palette.status.warning.main })} fontSize="small" />;
    case 'info':
      return <InfoIcon sx={(theme) => ({ color: theme.palette.status.info.main })} fontSize="small" />;
  }
};

/**
 * Takes an array of Notice objects and returns the highest notice level ( error > warning > info)
 */
export const getMostSevereNoticeType = (notices: Notice[]): Notice['type'] => {
  const types: Array<Notice['type']> = ['error', 'warning', 'info'];

  for (const type of types) {
    if (notices.some((notice) => notice.type === type)) {
      return type;
    }
  }

  return 'error';
};
